import { ReactNode } from 'react';

import { addStyles } from '../../utils/helpers';

const shadowOptions = {
  light: 'shadow-light',
  dark: 'shadow-dark',
  none: '',
};

export interface CardProps {
  /** The contents of the card */
  children?: ReactNode;
  /** DEPRECATED. Optional class names */
  className?: string;
  /** The HTML role of the card */
  role?: string;
  /** The shadow style of the card */
  shadow?: keyof typeof shadowOptions;
}

export const Card = ({ shadow = 'none', ...props }: CardProps) => {
  const { children, className, role } = props;

  return (
    <div
      role={role}
      className={addStyles(['flex bg-white rounded-lg overflow-hidden', shadowOptions[shadow], className])}
    >
      {children}
    </div>
  );
};

export default Card;
